"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const core_1 = require("@emotion/core");
const AuthBox_1 = __importDefault(require("../../sample/AuthBox"));
function AccountSpecifications({ authTitle, hasServiceAuthType, serviceKey, serviceName, }) {
    if (hasServiceAuthType) {
        return (core_1.jsx(react_1.Fragment, null,
            core_1.jsx(AuthBox_1.default, { api: serviceKey, authTitle: authTitle }),
            " account"));
    }
    return core_1.jsx(react_1.Fragment, null,
        serviceName,
        " account");
}
exports.default = AccountSpecifications;
